module.exports = __webpack_public_path__ + "e8ee284883ed6c8ad68cd30dd0350efa.pdf";